/* eslint-disable no-restricted-globals */

/**
 * Push a URL to the browser history.
 *
 * @param {String} rawUrl The new URL.
 */
const setHistory = (rawUrl) => {
  // Add passed query parms to the url
  const queryParamsEncoded = encodeURIComponent(window.location.search); // phpcs:ignore WordPressVIPMinimum.JS.Window.location
  const queryParamsFormatted = queryParamsEncoded
    .replace('%3F', '?')
    .replace('%26', '&')
    .replace('%3D', '=');
  const url = `${rawUrl}${queryParamsFormatted}`;

  if ('undefined' === typeof history || ! url) {
    return;
  }

  // Push new history state.
  if (
    null === history.state
    || 'undefined' === typeof history.state.slug
    || url !== history.state.slug
  ) {
    history.pushState(
      { slug: url },
      '',
      url,
    );

    // Send an event with the pushed URL.
    window.dispatchEvent(
      new CustomEvent(
        'nsSetHistory',
        {
          detail: { url },
        },
      ),
    );
  }
};

export default setHistory;
